import {
    Component, ElementRef,
    forwardRef,
    Input, ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MODAL_EDITOR_TOKEN, ModalEditorBase } from '../../../classes/modal-editor-base';
import { dateToNgbDate } from 'apps/account/src/account-shared/classes/custom-ngb-adapter';
import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DateUtils } from '@flipto/shared/src/lib/utils/common/time/date-utils';
import { formatDate } from '@angular/common';
import { NgbCustomFormatter } from '../../../../../classes/custom-ngb-formatter';

@Component({
    selector: 'ft-datepicker-editor',
    templateUrl: './datepicker-editor.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => DatePickerEditor)
        },
        {
            provide: MODAL_EDITOR_TOKEN,
            useExisting: DatePickerEditor
        },
        {
            provide: NgbDateParserFormatter,
            useClass: NgbCustomFormatter
        }
    ],
    standalone: false
})
export class DatePickerEditor extends ModalEditorBase {
    @Input() placeholder = 'Select date';
    @ViewChild('inputElement', { static: false }) inputElement: ElementRef;

    constructor() {
        super();
    }

    mapValue(value: any): any {
        return (value instanceof NgbDate || value instanceof Object) ? value : dateToNgbDate(value);
    }

    onModelChange(value: any) {
        super.onModelChange(this.mapValue(value));
    }

    applyChanges() {
        if (this.isNgModelExist) {
            this.onChangeFn(this.mapOutputValue(this.value));
        }
        this.save.next(this.mapOutputValue(this.outputValue?.[this.name]) as any);
    }

    mapOutputValue(value: any): any {
        return DateUtils.ngbDateToDate(value);
    }
}


